import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './index.css';

import Index from './pages/index';

import SignIn from './pages/signin/signin';
import SignUp from './pages/signup/signup';

import Dashboard from './pages/dashboard/dashboard';
import Remote from './pages/remote/remote';
import RemoteItem from './pages/remote/remote-item';
import RemoteNew from './pages/remote/remote-new';

import Transaction from './pages/transaction/transaction';
import TransactionItem from './pages/transaction/transaction-item';

import Logs from './pages/logs/logs';

import Credits from './pages/credits/credits';

import PasswordReset from './pages/password-reset/password-reset';

import Payment from './pages/payment/payment';
import NotFound from './pages/404/404';



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
  // </React.StrictMode>
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="signin" element={<SignIn />} />
      <Route path="signup" element={<SignUp />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="password-reset" element={<PasswordReset />} />
      <Route path="remote" element={<Remote />} />
      <Route path="remote/new" element={<RemoteNew />} />
      <Route path="remote/:id" element={<RemoteItem />} />
      <Route path="credits" element={<Credits />} />
      <Route path="transaction" element={<Transaction />} />
      <Route path="transaction/:id" element={<TransactionItem />} />
      <Route path="logs" element={<Logs />} />
      <Route path='payment' element={<Payment />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);